import React from "react";
import AddressBoook from "../../component/addressBook/index";

export function AddressBook() {
  return <AddressBoook />;
}
